var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 21.209,8.037 c 0.519691,0.9851393 0.791207,2.082187 0.791,3.196 1.7e-5,1.1157 -0.27146,2.214647 -0.791,3.202 -0.521959,1.012432 -1.246651,1.906639 -2.129,2.627 -0.892,0.732 -1.955,1.316 -3.188,1.752 -1.234,0.435 -2.531,0.653 -3.892,0.653 -0.52,0 -1.084,-0.04 -1.69,-0.12 C 8.567,21.117 6.77,22 4.92,22 4.725,22 4.591,21.914 4.52,21.743 4.474,21.538 4.507,21.383 4.617,21.278 l 0.02,-0.02 C 5.262,20.552 5.704,19.694 5.965,18.685 6.03,18.428 6.082,18.164 6.121,17.893 4.845,17.128 3.839,16.163 3.104,14.999 1.7515174,12.902845 1.6319307,10.240989 2.791,8.032 3.3129592,7.0195683 4.0376514,6.1253614 4.92,5.405 5.812,4.672 6.875,4.089 8.108,3.653 9.3585473,3.2147644 10.674903,2.9939062 12,3 c 1.36,0 2.658,0.218 3.892,0.653 1.233,0.436 2.296,1.02 3.188,1.752 0.883253,0.7214513 1.608048,1.6174865 2.129,2.632 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.2e9a5e60944fa554e27c6ab2b859e55b.svg";
export { ForwardRef as ReactComponent };